export default {
  colors: {
    'bg.canvas': {
      default: 'gray.50',
      _dark: 'gray.900',
    },
    'bg.surface': {
      default: 'white',
      _dark: 'gray.800',
    },
    'bg.subtle': {
      default: 'gray.50',
      _dark: 'gray.800',
    },
    'bg.muted': {
      default: 'gray.100',
      _dark: 'gray.700',
    },

    'fg.default': {
      default: 'gray.900',
      _dark: 'white',
    },
    'fg.emphasized': {
      default: 'gray.700',
      _dark: 'gray.200',
    },
    'fg.muted': {
      default: 'gray.600',
      _dark: 'gray.300',
    },
    'fg.subtle': {
      default: 'gray.500',
      _dark: 'gray.400',
    },
    'fg.inverted': {
      default: 'white',
      _dark: 'gray.950',
    },

    // TODO: rename to border.light
    'border.default': {
      default: 'gray.200',
      _dark: 'gray.700',
    },

    // TODO: rename to border.default
    'border.emphasized': {
      default: 'gray.300',
      _dark: 'gray.600',
    },

    // TODO: implement border.emphasized, gray 400

    'bg.accent.default': 'brand.600',
    'bg.accent.subtle': 'brand.500',
    'bg.accent.muted': 'brand.400',

    'fg.accent.subtle': 'brand.100',
    'fg.accent.muted': 'brand.50',
    'fg.accent.default': 'white',

    primary: {
      default: 'orange.500',
      _dark: 'orange.200',
    },
    secondary: {
      default: 'blue.500',
      _dark: 'blue.200',
    },
    accent: {
      default: 'slate.500',
      _dark: 'slate.200',
    },
    success: {
      default: 'green.500',
      _dark: 'green.200',
    },
    warning: {
      default: 'yellow.500',
      _dark: 'yellow.200',
    },
    error: {
      default: 'red.500',
      _dark: 'red.200',
    },

    placeholder: {
      default: 'gray.400',
      _dark: 'gray.500',
    },

    red: {
      default: 'red.200',
      _dark: 'red.400',
    },

    orange: {
      default: 'orange.200',
      _dark: 'orange.500',
    },

    yellow: {
      default: 'yellow.300',
      _dark: 'yellow.600',
    },
  },
};
